'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _css = require('antd/lib/button/style/css');

var _button = require('antd/lib/button');

var _button2 = _interopRequireDefault(_button);

var _css2 = require('antd/lib/checkbox/style/css');

var _checkbox = require('antd/lib/checkbox');

var _checkbox2 = _interopRequireDefault(_checkbox);

var _css3 = require('antd/lib/input/style/css');

var _input = require('antd/lib/input');

var _input2 = _interopRequireDefault(_input);

var _css4 = require('antd/lib/icon/style/css');

var _icon = require('antd/lib/icon');

var _icon2 = _interopRequireDefault(_icon);

var _css5 = require('antd/lib/form/style/css');

var _form = require('antd/lib/form');

var _form2 = _interopRequireDefault(_form);

var _css6 = require('antd/lib/select/style/css');

var _select = require('antd/lib/select');

var _select2 = _interopRequireDefault(_select);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * 用户登录表单
                                                                                                                                                                                                                                                                   */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Option = _select2.default.Option;

var FormItem = _form2.default.Item;

var LoginForm = _react2.default.createClass({
    displayName: 'LoginForm',
    handleSubmit: function handleSubmit(e) {
        var _this = this;

        e.preventDefault();
        this.props.form.validateFieldsAndScroll(function (err, values) {
            if (!err) {
                _this.props.onLogin(values);
            }
        });
    },
    checkPassword: function checkPassword() {
        var form = this.props.form;
        var password = form.getFieldValue('password');

    },
    render: function render() {
        var getFieldDecorator = this.props.form.getFieldDecorator;

        var formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 14 }
        };
        var tailFormItemLayout = {
            wrapperCol: {
                span: 14,
                offset: 6
            }
        };
        return _react2.default.createElement(
            _form2.default,
            { onSubmit: this.handleSubmit },
            _react2.default.createElement(
                FormItem,
                _extends({}, formItemLayout, { label: '\u90AE\u7BB1' }),
                getFieldDecorator('email', {
                    rules: [{ required: true, message: '请输入邮箱!' }]
                })(_react2.default.createElement(_input2.default, { addonBefore: _react2.default.createElement(_icon2.default, { type: 'mail' }), placeholder: '\u8BF7\u8F93\u5165\u90AE\u7BB1', type: 'email' }))
            ),
            _react2.default.createElement(
                FormItem,
                _extends({}, formItemLayout, { label: '\u5BC6\u7801' }),
                getFieldDecorator('password', {
                    rules: [{
                        required: true,
                        message: '请输入密码!'
                    }]
                })(_react2.default.createElement(_input2.default, { addonBefore: _react2.default.createElement(_icon2.default, { type: 'lock' }), placeholder: '\u8BF7\u8F93\u5165\u5BC6\u7801', type: 'password' }))
            ),
            _react2.default.createElement(
                FormItem,
                tailFormItemLayout,
                getFieldDecorator('remember', {
                    valuePropName: 'checked',
                    initialValue: true
                })(_react2.default.createElement(
                    _checkbox2.default,
                    null,
                    '\u4E09\u5929\u5185\u81EA\u52A8\u767B\u5F55'
                )),
                _react2.default.createElement(
                    _button2.default,
                    { type: 'primary', htmlType: 'submit', className: 'login-form-button' },
                    '\u767B\u5F55'
                )
            )
        );
    }
});

exports.default = _form2.default.create({})(LoginForm);


//////////////////
// WEBPACK FOOTER
// ./src/js/components/login_form.js
// module id = 1564
// module chunks = 0